import { deleteOperator } from 'app/redux/xrayGeneratorConfiguration/actions';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { Button, Confirm, Modal } from 'semantic-ui-react';

const OperatorDeleteButton = ({ operator }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();

  const handleButtonClick = () => setOpen(true);
  const handleConfirm = () => {
    dispatch(deleteOperator(operator));
    setOpen(false);
  };
  const handleCancel = () => setOpen(false);

  return (
    <div>
      {operator}
      <Button onClick={handleButtonClick} icon="trash" data-testid="operator-delete-button" />
      <Confirm
        open={open}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        header={
          <Modal.Header>
            <FormattedMessage id="xray_generator.operator.deleteOperator.header" />
          </Modal.Header>
        }
        content={
          <Modal.Content>
            <FormattedMessage
              id="xray_generator.operator.deleteOperator.text"
              values={{ operator }}
            />
          </Modal.Content>
        }
        confirmButton={
          <Button data-testid="delete-button-confirmation" negative>
            <FormattedMessage id="xray_generator.operator.delete" />
          </Button>
        }
        cancelButton={
          <Button>
            <FormattedMessage id="xray_generator.operator.cancel" />
          </Button>
        }
      />
    </div>
  );
};

export default OperatorDeleteButton;
